import { formatPlayerName } from './nameUtils';
import { GAME_TYPE_CAPABILITIES } from './gameTypeUtils';

/**
 * @param {object|null} tournament
 * @returns {boolean}
 */
export const isSinglesTournament = (tournament) => {
  if (!tournament) return false;
  const gt = tournament.game_type;
  if (gt && typeof gt.is_doubles === 'boolean') {
    return !gt.is_doubles;
  }
  const cap = GAME_TYPE_CAPABILITIES[tournament.game_type_id];
  return Boolean(cap && cap.isDoubles === false);
};

/**
 * @param {object} entry - tournament_entries row with optional tournament_entry_players
 * @returns {object[]} Player rows (embedded `player`), sorted by position
 */
export const getEntryPlayersSorted = (entry) => {
  if (!entry) return [];
  const rows = entry.tournament_entry_players || [];
  return [...rows]
    .sort((a, b) => (a.position || 0) - (b.position || 0))
    .map((r) => r.player)
    .filter(Boolean);
};

/**
 * @param {object} entry
 * @param {boolean} [isSinglesHint] - if omitted, inferred from player count
 * @returns {string}
 */
export const formatTournamentEntryLabel = (entry, isSinglesHint) => {
  const players = getEntryPlayersSorted(entry).map((p) => formatPlayerName(p));
  if (players.length === 0) return 'TBD';
  const singles = isSinglesHint ?? players.length === 1;
  if (singles) return players[0] || 'TBD';
  if (players.length === 1) return players[0];
  return `${players[0]} & ${players[1]}`;
};

/**
 * Shape expected by standings UI / legacy "team" displays
 * @param {object} entry
 * @returns {{ id: string, withdrawn_at: any, player1: object|null, player2: object|null, tournament_entry_players?: any[] }}
 */
export const entryToLegacyTeamShape = (entry) => {
  if (!entry) return null;
  const sorted = getEntryPlayersSorted(entry);
  return {
    id: entry.id,
    withdrawn_at: entry.withdrawn_at,
    player1: sorted[0] || null,
    player2: sorted[1] || null,
    replacement_player1_id: entry.replacement_player1_id,
    replacement_player2_id: entry.replacement_player2_id,
    seed: entry.seed,
    created_at: entry.created_at,
    tournament_entry_players: entry.tournament_entry_players
  };
};

/**
 * Build team1Players / team2Players arrays for createGameDirect (1 or 2 players per side)
 */
export const entryPlayersForSessionGame = (entry) => {
  const sorted = getEntryPlayersSorted(entry);
  return sorted.map((p) => ({ id: p.id, ...p }));
};
